import { useSyncExternalStore } from 'react';

/** @typedef {import('../domain/fullCalendar/fullCalendarUseCase').TimelineDateSelection} TimelineDateSelection */

/** @typedef {{ isOpen: boolean, selection: TimelineDateSelection | null }} DateSelectionMenuState */

/** @type {DateSelectionMenuState} */
let state = {
  isOpen: false,
  selection: null,
};

/** @type {Set<() => void>} */
const listeners = new Set();

/**
 * @returns {DateSelectionMenuState}
 */
function getSnapshot() {
  return state;
}

/**
 * @param {() => void} listener
 * @returns {() => void}
 */
function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * Notifie les abonnés.
 */
function emitChange() {
  listeners.forEach((listener) => listener());
}

/**
 * @param {TimelineDateSelection} selection
 */
export function openDateSelectionMenu(selection) {
  state = {
    isOpen: true,
    selection,
  };
  emitChange();
}

/**
 * Ferme le menu de sélection de plage.
 */
export function closeDateSelectionMenu() {
  state = {
    isOpen: false,
    selection: null,
  };
  emitChange();
}

/**
 * @returns {DateSelectionMenuState & { closeDateSelectionMenu: () => void }}
 */
export function useDateSelectionMenu() {
  const snapshot = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return {
    ...snapshot,
    closeDateSelectionMenu,
  };
}
